module.exports = __webpack_public_path__ + "static/media/documents.0b417d26.svg";